<template>
    <el-dialog
        title="设备绑定"
        :visible.sync="dialogVisible" :close-on-click-modal='false'>
        <div>
            <el-form :model="bindForm" :rules="rules" ref="bindForm">
                <div style="padding:0px">
                    <el-card class="box-card" shadow="never" style="border-bottom: none;">
                        <div slot="header" class="clearfix">
                            <i class="el-icon-set-up" style="margin-right:5px"></i><span>设备信息</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12" class="item">
                                <el-form-item label="设备号" required prop="deviceId">
                                    <el-input v-model="bindForm.deviceId" placeholder="请输入设备号"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="监控地址" required prop="url">
                                    <el-input v-model="bindForm.url"  placeholder="请输入监控地址"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="绑定类型" required prop="type">
                                    <el-select v-model="bindForm.type" placeholder="请选择绑定类型" style="width:100%">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="设备位置" required prop="location">
                                    <el-input v-model="bindForm.location" placeholder="请填写设备位置"></el-input>
                                </el-form-item>
                            </el-col>
                            <div v-if="bindForm.type==2">
                                <el-col :span="12" class="item">
                                    <el-form-item label="机构名称" required prop="name">
                                        <el-input v-model="bindForm.name" placeholder="请填写机构名称"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="item">
                                    <el-form-item label="机构地址" required prop="address">
                                        <el-input v-model="bindForm.address" placeholder="请填写机构地址"></el-input>
                                    </el-form-item>
                                </el-col>
                            </div>
                        </el-row>
                    </el-card>
                    <el-card class="box-card" shadow="never" v-if="bindForm.type==1">
                        <div slot="header" class="clearfix">
                            <i class="el-icon-user" style="margin-right:5px"></i><span>老人选择</span>
                            <el-popover
                                placement="top-start"
                                title=""
                                width="200"
                                trigger="hover"
                                content="搜索后点击列表行可进行选择！选中后高亮。">
                                <i class="el-icon-warning" style="margin-left:5px;color:#e6a23c"  slot="reference"></i>
                                <!-- <el-button  type="info" icon="el-icon-message" circle slot="reference"></el-button> -->
                            </el-popover>
                            <el-button v-if="haveEl" type="text" style="float: right; padding: 3px 0" icon="el-icon-sort" @click="cutElderly">切换</el-button>
                        </div>
                        <div style="float:right">
                            <el-input  placeholder="请输入姓名" v-model="searchForm.name" clearable style="margin-right:10px;width:200px"></el-input>
                            <el-input  placeholder="请输入手机号" maxlength="11" v-model="searchForm.phone" clearable style="margin-right:10px;width:200px"></el-input>
                            <el-button type="primary" icon="el-icon-search" @click="getElderly">查询</el-button>
                        </div>
                        <div style="clear:both;height:15px"></div>
                        <el-table class="userTable"
                            :data="elderlyInfo"
                            style="width: 100%;" border :max-height="200"
                        v-loading="loading" @row-click='rowClick' highlight-current-row>
                            <el-table-column label="姓名" prop="name" width="150"></el-table-column>
                            <el-table-column label="手机号" prop="phone"></el-table-column>
                            <el-table-column prop="createTime" :formatter="timefilter" label="注册时间" ></el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="bindSubmit">绑 定</el-button>
        </span>
    </el-dialog>

</template>
<script>
    import {postAxios} from "@/common/axios";
    import {timefilters} from "@/common/times";
    import { getInstitutionCode } from "@/utils/auth";
    export default {
        name: "bind",
        props:["governmentList","platform"],
        data() {
            return {
                dialogVisible: false,
                bindForm:{
                    deviceId:'',
                    url:'',
                    type:1,
                    address:'',
                    location:'',
                    name:'',
                    platform:'institution',
                    userCode:'',
                    governmentCode:'',
                },
                rules:{
                    deviceId:[{ required: true, message: '请输入设备号', trigger: 'blur' }],
                    type:[{ required: true, message: '请选择绑定类型', trigger: 'blur' }],
                    location:[{ required: true, message: '请填写设备位置', trigger: 'blur' }],
                    url:[{ required: true, message: '请输入设备监控地址', trigger: 'blur' }],
                    address:[{ required: true, message: '请填写机构地址', trigger: 'blur' }],
                    name:[{ required: true, message: '请填写机构名称', trigger: 'blur' }],
                },
                searchForm:{
                    name:'',
                    phone:'',
                    platform:"institutionApi",
                    governmentList:[]
                },
                haveEl:false,
                elderlyInfo:[],
                loading:false,
                options:[{
                    label:'个人',
                    value:1
                },{
                    label:'机构',
                    value:2
                }]
            }
        },
        created() {
        },
        components: {
            // BasicInfo,Device
            // popUp
        },
        methods: {
            //初始化
            init(){
                Object.assign(this.$data, this.$options.data());
                this.dialogVisible=true;
                this.$nextTick(()=>{
                    if(this.$refs.bindForm){
                        this.$refs.bindForm.clearValidate()
                    }
                })
                this.searchForm.platform="institution";
                this.bindForm.platform="institution";
                this.bindForm.governmentCode=getInstitutionCode();
                this.searchForm.governmentList.push(getInstitutionCode());
            },
            timefilter(){
                return timefilters(arguments[2]);
            },
            rowClick(row){
                console.log(row);
                this.elderlyInfo=[row];
                this.haveEl=true;
                this.bindForm.userCode=row.userCode
            },
            getElderly(){
                if(!this.searchForm.name&&!this.searchForm.phone){
                    return this.$message.error("请至少输入一项查询！");
                }
                this.loading=true;
                var that=this;
                postAxios(this.$deviceUrl + "UserDevice/GetPlatformUserInfo",this.searchForm,false).then(resolve=>{
                    this.elderlyInfo = resolve;
                    console.log(this.elderlyInfo)
                    this.loading = false;
                }).catch(()=>{
                    that.loading = false;
                })
            },
            cutElderly(){
                this.elderlyInfo=[];
                this.haveEl=false
            },
            bindSubmit(){
                this.$refs.bindForm.validate((valid) => {
                    if(valid){
                        if(!this.bindForm.userCode && this.bindForm.type==1){
                            return this.$message.error("请选择所绑定的老人！点击列表行可选中")
                        }
                        var that=this;
                        postAxios(this.$deviceUrl + "DhCamera/Add",this.bindForm,false).then(()=>{
                            this.dialogVisible=false;
                            this.$emit("getList");
                        }).catch(()=>{
                            that.loading = false;
                        })
                    }else {
                        return false;
                    }
                })
            }
        }
    }
</script>

<style lang='scss' scoped>
    /deep/ .el-dialog__body{
        padding: 0;
        background:#fff !important;
    }

//    /deep/ .el-form-item__label{
//         text-overflow: ellipsis;
//         white-space: nowrap;
//         width: 100%;
//         overflow: hidden;
//     }
.clearfix{
    font-size: 17px;
}
    .userTable /deep/ .el-table__body tr.current-row>td{
        color: #fff;
        background-color: #81d7dd !important;
    }

</style>
